import { useEffect, useState } from 'react';
import { animationDuration } from '@config';

const useAnimationFinished = (scrolled: boolean, timeout = 100) => {
  const [animationFinished, setAnimationFinished] = useState(true);

  useEffect(() => {
    setAnimationFinished(false);

    const timeoutId = setTimeout(() => {
      setAnimationFinished(true);
    }, animationDuration + timeout);

    return () => clearTimeout(timeoutId);
  }, [scrolled, timeout]);

  return animationFinished;
}

export { useAnimationFinished };